var _image;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlertaAlta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAPFBMVEUAAADzAADzAADyAADx AADzAADyAADyAAD/AADyAADzAADyAAD/AADzAADyAADyAADzAADyAADyAAD////YAJcgAAAAEnRS TlMAw83x8cTEvQz6+ckUFfz7wsIsv9StAAAAAWJLR0QTDLtclgAAAAd0SU1FB+YJEAAaOMnvJZQA AACBSURBVDjL3ZNLDoAgDEQHf+Bfe//DGhISoC0oW2fFdF4bIAAkoiCookwiNsTUFdqzpcx7bwZJ sCYxg0pA8GMZmPj5oBWoBhCz1ue2AoiRpN0wq/wRkALe8lbAueqmZu8XlmNlPukw357c+6ONpc2b XeaROIBTy4GLX8Dd+nmL3/8Bk7cxUiB2dqkAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjItMDktMTVU MjI6MjY6NTYrMDI6MDBUCW9PAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIyLTA5LTE1VDIyOjI2OjU2 KzAyOjAwJVTX8wAAAABJRU5ErkJggg=="
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertaAlta);
export default __webpack_public_path__ + "static/media/alertaAlta.7657133d.svg";
export { ForwardRef as ReactComponent };